export default __webpack_public_path__ + "static/media/06.568dfe59.jpg";